<ng-container *ngIf="showActionBar">
  <div
    class="bl-display--flex bl-flex-flow--wrap ww-flex-flow-sm--nowrap bl-flex-direction--column-reverse bl-margin-top--32">
    <p class="bl-align-self--center bl-margin--0 bl-margin-top--24 bl-margin-top-sm--0 bl-flex--auto">
      <button *ngIf="checkPreviousPageButtonVisibility()" type="button" (click)="onBackClicked()"
        [attr.data-automation-id]="'back-to-previous-button'" class="bl-button bl-button-tertiary">
        <span class="bl-display--flex bl-align-items--center bl-justify-content--center">
          <i class="cu-chevron-left bl-margin-right--8"></i>{{backLabel ? backLabel : 'Back to ' + previousPageLabel }}
        </span>
      </button>
    </p>
    <ea-button-loader *ngIf="page.helper.isNextButtonVisible" buttonType="button"
      [attr.data-automation-id]="'save-and-continue-button'" [buttonClass]="'bl-width--100 bl-width-sm--auto'"
      buttonId="go-to-{{page.nextPage?.path}}-button" [text]="continueLabel" [buttonDisabled]="isDisabled"
      [loading]="isDisabled || isLoading" (event)="onContinueClicked()">
    </ea-button-loader>
  </div>
</ng-container>


<div *ngIf="page.showRemove && page.config.removePosition === 'bottom'" class="bl-display--flex bl-justify-content--flex-end bl-margin-bottom--16">
  <button class="bl-button bl-button-tertiary bl-width--100" id="remove-coapplicant-btn-id" (click)="page.remove()" title="Remove Applicant" id="remove-oao-applicant">
    <span class="bl-white-space--normal">{{ removeCoApplicantLabel }}</span>
  </button>
</div>

